import * as Sentry from '@sentry/react';

const isProd = import.meta.env.MODE === 'production';

if (isProd) {
  Sentry.init({
    dsn: 'https://10e991dac3a6fac4584e88411a4a5388@o4510388314243072.ingest.us.sentry.io/4510388387053568',
    sendDefaultPii: true,
  });

  const storedUser = localStorage.getItem('amplifyUser');
  const user = storedUser ? JSON.parse(storedUser) : null;

  if (user) {
    Sentry.setUser({
      id: user.sub,
      email: user.email,
      name: user.name,
      phone: user.phone_number,
    });
  }
}

export default Sentry;
